export type SelectionRange = string | undefined
export type PositionData = {
	path: Array<PathStep | string>
	x: number
	y: number
	selectionRange?: SelectionRange
}
export type PathStep = {
	name: string
	index: number
	id: string
	class: string
	text?: string
}
export const pathBuilder = (event: MouseEvent): PositionData => {
	const path: Array<PathStep | string> = []
	let node = event.target as HTMLElement

	while (node && node !== document.body) {
		let index = 1
		let sibling = node.previousElementSibling

		while (sibling) {
			if (sibling.nodeName === node.nodeName) {
				index++
			}
			sibling = sibling.previousElementSibling
		}

		path.unshift({
			name: node.nodeName,
			index: index,
			id: node.id,
			class: node.className,
			text: node.textContent?.substring(0, 50),
		})

		node = node.parentNode as HTMLElement
	}

	path.unshift("body")

	// @ts-expect-error expected to be HTMLElement
	const rect = event.target?.getBoundingClientRect()

	const x = event.clientX - rect.left
	const y = event.clientY - rect.top

	const data: PositionData = {
		path: path,
		x,
		y,
	}

	return data
}
